// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refLinkTypeService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount() {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refLinkTypes/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refLinkTypes/${id}`).then(handleResponse);
}

function add(refLinkType) {
    return axios.post('/refLinkTypes', refLinkType).then(handleResponse);
}

function update(refLinkType) {
    return axios.put(`/refLinkTypes/${refLinkType.refLinkTypeId}`, refLinkType).then(handleResponse);
}

function deleteEntity(refLinkType) {
    return axios.delete(`/refLinkTypes/${refLinkType.refLinkTypeId}`).then(handleResponse);
}
